









































































import { Component, Prop, Vue } from "vue-property-decorator";

import { Const } from '@/const';

import Header from "@/commonComponents/header/header.vue"

import LeftController from "./leftController/leftController.vue";
import TemplateView from "./templateView/templateView.vue";
import SelectTemplateColor from "./selectTemplateColor/selectTemplateColor.vue";
import SnsModal from "./snsModal/snsModal.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import IeAlertModal from "@/commonComponents/alertModal/ieAlertModal/ieAlertModal.vue";
import AfterLoadCsvModal from "@/commonComponents/alertModal/afterLoadCsvModal/afterLoadCsvModal.vue";

import { Data } from "@/data/data";
import { TemplateCategory } from "@/data/templateCategory/templateCategory";
import { Template } from "@/data/template/template";
import { TemplateColor } from "@/data/templateColor/templateColor";
import { ProductCategoryList } from "@/for-api/product_category_list/productCategoryList/productCategoryList";
import { templateSearchInfo } from "@/definitions/templateSearchInfo";
import { CloudAccount } from "@/cloudAccount/cloudAccount";

import { Document } from '@/model/document2/document';
import { InsertionData, ColumnData } from '@/model/document2/insertionData/insertionData';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';

import { NewDesignCommand } from '@/commands/newDesignCommand';
import { ReplaceTemplateCommand } from '@/commands/replaceTemplateCommand';
import { InsertProfileCommand } from '@/commands/insertProfileCommand';

import { CompatibleHelper } from "@/helper/compatibleHelper";
import { ImageHelper } from "@/helper/imageHelper";
import { RequestHelper } from "@/helper/requestHelper";
import { EncryptionHelper } from "@/helper/encryptionHelper"
import { InsertionHelper } from "@/helper/insertionHelper"
import { UserAgentHelper } from "@/helper/userAgentHelper"
import { LogHelper } from "@/helper/logHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { DebugHelper } from "@/helper/debugHelper";
import Spinner from "vue-spinkit";
import { FileHelper } from '../../helper/fileHelper';
import { ProfileData } from '@/utilityModels/profileData';
import { putRecentTemplate } from '@/data/items-recent';
import { getTemplateContent } from '@/services/getTemplateContent';

const isElement = (x: any): x is Element => x instanceof Element;

@Component({
  components: {
    Header,
    LeftController,
    TemplateView,
    SelectTemplateColor,
    SnsModal,
    Spinner,
    LoadingScreen,
    Tutorial,
    License,
    IeAlertModal,
    AfterLoadCsvModal
  }
})
export default class SelectTemplate extends Vue
{
    private isSnsModalVisible = false;

    mounted()
    {
        if(UserAgentHelper.getBrowser() == "ie"
        && (!CookieHelper.hasItem("ieAlertShown") || CookieHelper.hasItem("ieAlertShown") && CookieHelper.getItem("ieAlertShown") == false)){
            this.isIeAlertModal = true;
        }
        else if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("selectTemplateTutorial") != true){
            this.isTutorial = true;
        }
    }

    loading = false;
    isTutorial = false;
    isLicense = false;
    isIeAlertModal = false;

    private get loadingTitle() { return "読み込み中"; }
    private get loadingMessage() { return "読み込んでいます…"; }

    get browser(){
        return UserAgentHelper.getBrowser();
    }

    public get currentDocument() : Document
    {
        return this.$store.getters.document;
    }

    private get currentTab() { return "/SelectTemplate"; }

    isSelectTemplateColorVisible = false;

    treeLog = { id : 0, hierarchy : 0};

    get rootData(): Data {
        return this.$store.getters.data;
    }

    private get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    //----------カテゴリー----------
    get templateCategoryList(): TemplateCategory[] {
        return this.rootData.templateCategoryList;
    }

    get selectedTemplateCategory(): TemplateCategory {
        return this.rootData.selectedTemplateCategory;
    }

    get searchSelection(): any[] {
        return this.rootData.searchSelection;
    }

    selectTemplateCategory(templateCategoryId : number , templateCategoryHierarchy : number){
        this.rootData.selectTemplateCategory(templateCategoryId , templateCategoryHierarchy)
    }

    createSearchSelection(value: string) {
        this.rootData.searchSelection = [];
        if (value != "") {
            this.rootData.createSearchSelection(value);
        }
    }

    //----------カテゴリー----------

    //----------テンプレート----------
    get templateList(): Template[] {
        DebugHelper.trace(this.rootData.templateList)
        return this.rootData.templateList;
    }

    get selectedTemplate(): Template {
        return this.rootData.selectedTemplate;
    }

    selectTemplate(templateId: number)
    {
        if(templateId == Const.TEMPLATE_ID_TWITTER || templateId == Const.TEMPLATE_ID_FACEBOOK)
        {
            DebugHelper.trace("selectTemplate: SNSテンプレートは選べない")
            return;
        }

        this.rootData.selectTemplate(templateId, true);

        if(templateId == 0)
        {
            // "テンプレートなし" を選んだ
            this.onOk(false, 0);
        }
        else
        {
            // その他のテンプレート
            this.updateSelectDesignRotate();
            this.isSelectTemplateColorVisible = true;
        }
    }
    //----------テンプレート----------

    // 編集面回転の設定更新
    private updateSelectDesignRotate()
    {
        var flowMode = this.$store.getters.applicationState.flowMode;
        var page = flowMode == 1 ? this.currentDocument.pageList[0] : this.currentDocument.pageList[this.currentDocument.currentPageIndex];
        var position = flowMode == 1 ? 0 : page.currentDesignPosition;
        var currentDesign = page.getSurface(this.currentDocument.isReverseSurface).getDesign(position);
        if(currentDesign != null)
        {
            // カレントデザインの回転角と一致させる
            this.$store.getters.data.designDirection = Math.round(currentDesign.rotate / 90);
        }
        else
        {
            // 0に設定
            this.$store.getters.data.designDirection = 0;
        }
    }

    //----------テンプレートカラー----------

    get templateColorList() : TemplateColor[]{
        return this.rootData.templateColorList
    }

    get selectedTemplateColor() : TemplateColor{
        return this.rootData.selectedTemplateColor
    }

    selectTemplateColor(templateColor){
        this.rootData.selectTemplateColor(templateColor)
    }

    //----------テンプレートカラー----------

    get displayResembles(): boolean {
        return this.rootData.displayResembles;
    }

    changeDisplayResembles() {
        this.rootData.changeDisplayResembles();
    }

    loadNew(visibility) {
        this.$nextTick(() => {
            if (visibility) {
                this.rootData.createTemplateList("loadNew")
            }
        });
    }

    get isLoadAllVisible(): boolean {
        // return true
        return this.rootData.isLoadAllVisibleTemplate;
    }

    get isLoadNewVisible(): boolean {
        return this.rootData.isLoadNewVisibleTemplate;
    }

    private onOk(isKeepRatio : boolean, rotate : number)
    {
        // 「デザインなし」以外のテンプレートを最近使った項目に追加する
        if (this.selectedTemplate.id) {
            this.selectedTemplate.recentUsedAt = Date.now();
            putRecentTemplate(this.selectedTemplate);
        }

        this.loading = true;

        var flowMode = this.$store.getters.applicationState.flowMode;

        var next = flowMode == 1 ? "/InsertionEditor" : "/DesignEditor";
        // 新規デザイン作成
        if(flowMode == 1)
        {
            // 差し込みの場合はアンドゥリドゥに残さない
            var page = this.currentDocument.pageList[0];
            var command = new NewDesignCommand(0, page, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
            this.currentDocument.undoRedoManager.init();
        }
        else
        {
            var page = this.currentDocument.pageList[this.currentDocument.currentPageIndex];
            var command = new NewDesignCommand(page.currentDesignPosition, page, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
        }
        if(this.selectedTemplate.id == 0)
        {
            // テンプレートなし
            var logValue = {
                productId : this.rootData.selectedProduct.id,
                code : this.rootData.selectedPaper.code,
                templateId : null,
                templateCategoryId : null,
                hierarchy : this.treeLog.hierarchy
            };
            LogHelper.sendLog("300" , logValue);
            this.loading = false;
            this.$router.push(next);
        }
        else
        {
            // テンプレートの貼り付け
            this.pasteTemplate(true, isKeepRatio, rotate, (templateDoc : Document) =>
            {
                // 終了プロセスの定義
                var finishProcess = () =>
                {
                    // 正常終了
                    var logValue = {
                            productId : this.rootData.selectedProduct.id,
                            code : this.rootData.selectedPaper.code,
                            templateId : this.rootData.selectedTemplate.id,
                            templateCategoryId : this.rootData.selectedTemplateCategory.id,
                            hierarchy : this.treeLog.hierarchy
                        };
                    LogHelper.sendLog("300" , logValue);
                    this.loading = false;
                    this.$router.push(next);
                };

                if(flowMode == 1)
                {
                    // テンプレートウィンドウ消去
                    this.isSelectTemplateColorVisible = false;
                    this.loading = false;
                    if(templateDoc.useInsertion)
                    {
                        // 差し込みデータを適用するか？
                        let modal = this.$refs.afterLoadCsvModal as AfterLoadCsvModal;
                        modal.open((result : string) =>
                        {
                            if(result == "ok")
                            {
                                // 適用する
                                this.applyDocumentInsertionData(templateDoc);
                            }
                            else
                            {
                                // 空のデータを作成
                                this.createBlankInsetionData();
                            }
                            this.resetSelection();
                            this.loading = true;
                            finishProcess();
                        });  
                    }
                    else
                    {
                        let modal = this.$refs.afterLoadCsvModal as AfterLoadCsvModal;
                        modal.open((result : string) =>
                        {
                            if(result == "ok")
                            {
                                // 自動作成
                                this.createAutoInsertionData();
                            }
                            else
                            {
                                // 空のデータを作成
                                this.createBlankInsetionData();
                            }
                            this.resetSelection();
                            this.loading = true;
                            finishProcess();
                        });
                    }
                }
                else
                {
                    // 差し込み以外

                    // プロフィールが自動適用かどうか調べる。
                    if(CookieHelper.hasItem("isProfileAppliedAutomatically") &&
                        CookieHelper.getItem("isProfileAppliedAutomatically") === true)
                    {
                        // 自動適用がON
                        DebugHelper.trace("プロフィールを自動適用します。")
                        var page = this.currentDocument.pageList[0];
                        var design = page.getSurface(this.currentDocument.isReverseSurface).getDesign(0);
                        if(design != null)
                        {
                            if(CookieHelper.hasItem("profile"))
                            {
                                // プロフィールを取得する
                                var profileSaveData = CookieHelper.getItem("profile");
                                var profileData = ProfileData.createFromSaveData(profileSaveData);
                                // プロフィールを適用する
                                var command = new InsertProfileCommand(profileData, design, () => {});
                                design.undoRedoManager.do(command);
                                // アンドゥリドゥマネージャはクリアする
                                design.undoRedoManager.init();
                            }
                        }
                    }
                    finishProcess();
                }
            }, () =>
            {
                // 異常時も遷移はする
                this.loading = false;
                this.$router.push(next);
            });
        }
    }

    private applyDocumentInsertionData(templateDoc)
    {
        // 関連付けデータをまるまるコピー
        this.currentDocument.insertionData = templateDoc.insertionData;
    }

    private applyInsertionLayerData(templateDoc)
    {
        // 関連付けデータから、位置情報だけをコピーする
        let insertionData = new InsertionData();
        if(insertionData.getRowDataCount() == 0)
            insertionData.addRowData();
        for(let i = 0; i < templateDoc.insertionData.getColumnDataCount(); ++i)
        {
            // 列ごとの情報をコピーする。
            insertionData.columnDataArray.push(templateDoc.insertionData.getColumnData(i).clone());
        }
        // 最初の行のセル内容のみコピーする。
        if(insertionData.getRowDataCount() > 0)
            insertionData.rowDataArray[0].cellDataArray = templateDoc.insertionData.rowDataArray[0].cellDataArray;
        insertionData = InsertionHelper.addColumnDataToInitCount(insertionData);
        this.currentDocument.insertionData = insertionData;
    }

    private createAutoInsertionData()
    {
        // 自動適用する
        let page = this.currentDocument.pageList[0];
        let design = page.getSurface(this.currentDocument.isReverseSurface).getDesign(0);
        let insertionData = new InsertionData();
        if(design != null)
            insertionData = InsertionHelper.applyDesignToInsertionData(insertionData, design);
        this.currentDocument.insertionData = InsertionHelper.addColumnDataToInitCount(insertionData);
    }

    private resetSelection()
    {
        this.currentDocument.currentPageIndex = 0;
        let page = this.currentDocument.pageList[0];
        page.currentDesignPosition = 0;
        this.currentDocument.selectedInsertionRow = 0;
        this.currentDocument.selectedInsertionColumn = 0;
        this.currentDocument.selectedInsertionWholeColumn = -1;
    }

    private createBlankInsetionData()
    {
        let insertionData = new InsertionData();
        if(insertionData.getRowDataCount() == 0)
            insertionData.addRowData();
        this.currentDocument.insertionData = InsertionHelper.addColumnDataToInitCount(insertionData);
    }

    private pasteTemplate(isNewDesign : boolean, isKeepRatio : boolean, rotate : number, completion : (templateDoc : Document) => void, error : () => void)
    {
        var flowMode = this.$store.getters.applicationState.flowMode;
        getTemplateContent(this.selectedTemplate.id).then(data => {
            try
            {
                // 取得ファイルデータを読み込む
                // ドキュメントの作成
                var doc = FileHelper.loadDocumentAnyway(data.content);
                DebugHelper.trace(doc);
                if(doc == null)
                {
                    error();
                    return;
                }
                // カレントデザイン取得 *差し込みの場合は0に差し込む
                var page = flowMode == 1 ? this.currentDocument.pageList[0] : this.currentDocument.pageList[this.currentDocument.currentPageIndex];
                var position = flowMode == 1 ? 0 : page.currentDesignPosition;
                var currentDesign = page.getSurface(this.currentDocument.isReverseSurface).getDesign(position);
                if(currentDesign != null)
                {
                    var command = new ReplaceTemplateCommand(currentDesign, doc, isKeepRatio, rotate, () => {});
                    currentDesign.undoRedoManager.do(command);
                    // アンドゥリドゥマネージャはクリアする
                    currentDesign.undoRedoManager.init();
                }
                completion(doc);
            }
            catch(e)
            {
                DebugHelper.trace("error" + e);
                error();
            }
        }).catch(reason => {
            DebugHelper.trace(reason);
            error();
        });
    }

    private unDraggableTreeLog(parameter){
        this.treeLog = parameter;
    }

    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("selectTemplateTutorial") != true;
    }

    private closeIeAlertModal(){
        this.isIeAlertModal = false;
        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else{
            this.isTutorial = CookieHelper.getItem("designEditorTutorial") != true;
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigThinColor(){
        var style = {
          backgroundColor : this.$store.getters.userConfigColors.buttonColorRgba
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

}
